import { Grid, Typography } from '@mui/material';
import { CustomeTextField } from '../../../generic/CustomeTextField';

import { ILegalTransactionRelationshipDataGenericV1 } from '../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipData';

import { ViewComponent } from '../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipData';

export const GenericRelationshipDataView: ViewComponent<
  ILegalTransactionRelationshipDataGenericV1
> = ({ data, setData }) => {
  return (
    <div>
      <Typography variant='h6' sx={{ mt: 5, mb: 2 }}>
        Nachricht des Mandanten
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomeTextField
            attr='notes'
            label='Anmerkungen'
            object={data}
            setObject={setData}
            type='string'
            rows={5}
          />
        </Grid>
      </Grid>
    </div>
  );
};
